@for (workInstruction of store.data$(); track workInstruction.id) {
  <div class="row pt-1 pb-1 mb-2 linked-items">
    <div class="col-11 d-flex align-items-center">
      <a class="cursor-pointer link" (click)="onClickedOpenStepper(workInstruction.id)">
        {{ workInstruction.name }}
      </a>
    </div>
    <div class="col-1 pl-30">
      <button
        mat-mini-fab
        class="me-xl-2 v-middle remove-button"
        (click)="onRemoveLinkClick(workInstruction)"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}
